import AdminServices from "../../services/admin.services";
import { getUpdatedUserDate } from "../Auth/auth.actions";
import { openNotification } from "../Notification/notifications.action";
import { UPDATE_TOUR_STATE, UPDATE_TOUR_STATUS, OPEN_SLIDER } from "./types";
import AuthServices from "../../services/auth.services";

export const changePassword = (data) => (dispatch) => {
  return AdminServices.changePassword(data)
    .then(({ data }) => {})
    .catch((err) => {
      const error =
        err?.response?.message ||
        err?.response?.statusText ||
        "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
    });
};
export const openSliderAction = (status) => (dispatch) => {
  return dispatch({
    type: OPEN_SLIDER,
    payload: status,
  });
};
export const updateTourState = (run, stepIndex, tourActive) => (dispatch) => {
  return dispatch({
    type: UPDATE_TOUR_STATE,
    payload: { run, stepIndex, tourActive },
  });
};

export const updateTourStatus = () => (dispatch) => {
  return AuthServices.updateTourStatus().then(
    (data) => {
      dispatch({
        type: UPDATE_TOUR_STATUS,
        payload: data.data,
      });
      dispatch(getUpdatedUserDate());
      return Promise.resolve();
    },
    (error) => {
      return Promise.reject();
    }
  );
};
